// extracted by mini-css-extract-plugin
module.exports = {"status":"_20LKPSfvSDxr8fGEtwGuHy","small":"d1iGfR8-GqC2suo7MctD9","active":"_3z70apYR_ebbyy3xhsCEsD","inactive":"_2Nq0ovdMz7hTygUjM1irZx"};